"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComplexCarePathwayType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ComplexCarePathwayType_Factory = /** @class */ (function () {
    function ComplexCarePathwayType_Factory() {
    }
    ComplexCarePathwayType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    ComplexCarePathwayType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return ComplexCarePathwayType_Factory;
}());
exports.ComplexCarePathwayType_Factory = ComplexCarePathwayType_Factory;
